import PropTypes from 'prop-types'
import { useState } from 'react'
import {
  MdDashboard,
  MdFlight,
  MdPerson,
  MdBusiness,
  MdLocationOn,
  MdAirplanemodeActive,
  MdLuggage,
  MdBookOnline,
  MdPeople,
  MdAnalytics,
  MdSettings,
  MdAccountCircle,
  MdNotifications,
  MdLock,
  MdLockOpen,
  MdMonitor,
  MdGroups,
} from 'react-icons/md'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import DarkModeToggle from '../../components/DarkModeToggle'
import './home.styles.css'

function HomePage({ title = 'Dialverse' }) {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false)
  const [isMenuLocked, setIsMenuLocked] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const navigationItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <MdDashboard className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/',
    },
    {
      id: 'simulations',
      label: 'Simulations',
      icon: <MdMonitor className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/simulations',
    },
    {
      id: 'flights',
      label: 'Flights',
      icon: <MdFlight className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/flights',
    },
    {
      id: 'pilots',
      label: 'Pilots',
      icon: <MdPerson className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/pilots',
    },
    {
      id: 'airlines',
      label: 'Airlines',
      icon: <MdBusiness className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/airlines',
    },
    {
      id: 'airports',
      label: 'Airports',
      icon: <MdLocationOn className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/airports',
    },
    {
      id: 'aircraft',
      label: 'Aircraft',
      icon: <MdAirplanemodeActive className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/aircraft',
    },
    {
      id: 'baggage',
      label: 'Baggage',
      icon: <MdLuggage className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/baggages',
    },
    {
      id: 'bookings',
      label: 'Bookings',
      icon: <MdBookOnline className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/bookings',
    },
    {
      id: 'passengers',
      label: 'Passengers',
      icon: <MdGroups className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/passengers',
    },
    {
      id: 'flight-attendants',
      label: 'Flight Crew',
      icon: <MdPeople className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/flight-attendants',
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: <MdAnalytics className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/analytics',
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: <MdSettings className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/settings',
    },
    {
      id: 'account',
      label: 'Account',
      icon: <MdAccountCircle className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />,
      path: '/account',
    },
  ]

  const handleMenuToggle = () => {
    setIsMenuLocked(!isMenuLocked)
  }

  const handleMouseEnter = () => {
    if (!isMenuLocked) {
      setIsMenuExpanded(true)
    }
  }

  const handleMouseLeave = () => {
    if (!isMenuLocked) {
      setIsMenuExpanded(false)
    }
  }

  const handleNavigation = (path) => {
    navigate(path)
  }

  const getCurrentPageTitle = () => {
    const currentItem = navigationItems.find((item) => item.path === location.pathname)
    return currentItem ? currentItem.label : 'Dashboard'
  }

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark transition-colors duration-300">
      <div className="flex h-screen">
        {/* Left Navigation Panel */}
        <div
          className={`relative bg-surface-light dark:bg-surface-dark border-r border-neutral-200 dark:border-neutral-700 transition-all duration-300 ease-in-out ${
            isMenuExpanded || isMenuLocked ? 'w-64' : 'w-16'
          }`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {/* App Title and Lock Toggle */}
          <div className="flex items-center justify-between p-4 border-b border-neutral-200 dark:border-neutral-700 h-20">
            <div className="flex items-center space-x-3 min-w-0 flex-1">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-sm">D</span>
              </div>
              {(isMenuExpanded || isMenuLocked) && (
                <h1 className="text-lg font-semibold text-neutral-900 dark:text-white transition-opacity duration-300 truncate">
                  {title}
                </h1>
              )}
            </div>

            <button
              onClick={handleMenuToggle}
              className={`p-1.5 rounded-md transition-all duration-200 flex-shrink-0 ${
                isMenuLocked
                  ? 'bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400'
                  : 'text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800'
              }`}
              title={isMenuLocked ? 'Unlock menu' : 'Lock menu'}
            >
              {isMenuLocked ? <MdLock className="w-4 h-4" /> : <MdLockOpen className="w-4 h-4" />}
            </button>
          </div>

          {/* Navigation Menu */}
          <nav className="mt-4">
            <ul className="space-y-1 px-2">
              {navigationItems.map((item) => (
                <li key={item.id}>
                  <button
                    className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-left transition-all duration-200 hover:bg-neutral-100 dark:hover:bg-neutral-800 group ${
                      location.pathname === item.path
                        ? 'bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400'
                        : ''
                    }`}
                    onClick={() => handleNavigation(item.path)}
                  >
                    <span className="text-lg">{item.icon}</span>
                    {(isMenuExpanded || isMenuLocked) && (
                      <span className="text-neutral-700 dark:text-neutral-300 font-medium transition-opacity duration-300">
                        {item.label}
                      </span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Expand Indicator */}
          {!isMenuExpanded && !isMenuLocked && (
            <div className="absolute -right-1 top-1/2 transform -translate-y-1/2">
              <div className="w-2 h-8 bg-primary-500 rounded-r-full opacity-60"></div>
            </div>
          )}
        </div>

        {/* Main Content Panel */}
        <div className="flex-1 flex flex-col">
          {/* Header */}
          <header className="bg-surface-light dark:bg-surface-dark border-b border-neutral-200 dark:border-neutral-700 px-6 py-4 h-20 flex items-center">
            <div className="flex items-center justify-between w-full">
              <h2 className="text-xl font-semibold text-neutral-900 dark:text-white">
                {getCurrentPageTitle()}
              </h2>
              <div className="flex items-center space-x-4">
                <button className="p-2 rounded-lg text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors duration-200">
                  <MdNotifications className="w-5 h-5" />
                </button>
                <DarkModeToggle />
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="flex-1 p-6 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}

HomePage.propTypes = {
  title: PropTypes.string,
}

export default HomePage
